export const ITEM_HEIGHT = 40;
export const VISIBLE_ITEMS = 5;
export const VIEWPORT_HEIGHT = ITEM_HEIGHT * VISIBLE_ITEMS;
export const COLUMN_PADDING_ITEMS = Math.floor(VISIBLE_ITEMS / 2);
export const LOOP_BLOCKS = 11;
export const WINDOW_OVERSCAN = 6;
export const SCROLL_IDLE_MS = 100;
export const SNAP_DURATION_MS = 200;
